import React, { useRef, useState, FormEvent, ChangeEvent } from "react";
import Form from "../../../components/common/form/Form";
import Modal from "../../../components/common/form/Modal";
import InputField from "../../../components/common/form/InputField";
import { OptionType } from "../../../helpers/utils/StyleUtils";
import ButtonTray from "../../../components/common/form/ButtonTray";
import { useUpdateProductOverridePriceMutation } from "../productsApi";
import { showToast } from "../../../helpers/utils/Utils";

interface OverridePriceModalProps {
    show: boolean;
    setShow: (show: boolean) => void;
    existingPrice: string;
    existingOverridePrice: string;
    productId: string;
    orderId?: string | null;
    existingDisplayPrice: string;
    existingOverrideDisplayPrice: string | null;
    logTypeList?: any[];
}

const OverridePriceModal: React.FC<OverridePriceModalProps> = ({
    show,
    setShow,
    existingPrice,
    existingOverridePrice,
    productId,
    orderId,
    existingDisplayPrice,
    existingOverrideDisplayPrice,
    logTypeList
}) => {
    const draggleRef = useRef<HTMLDivElement>(null);
    const [disable, setDisable] = useState(false);
    const [disableRevert, setDisableRevert] = useState(false);
    const [overridePrice, setOverridePrice] = useState<any>(existingOverridePrice);
    const [overrideDisplayPrice, setOverrideDisplayPrice] = useState<any>(existingOverrideDisplayPrice);
    const [updateProductOverridePriceApi, updateProductOverridePriceRes] = useUpdateProductOverridePriceMutation();


    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();

        if (overridePrice !== null || overrideDisplayPrice !== null) {
            setDisable(true);

            try {
                await updateProductOverridePriceApi({
                    productId: productId,
                    overridePrice: overridePrice,
                    overrideDisplayPrice: overrideDisplayPrice,
                });
                setShow(false);
            } catch (error) {
                showToast("Failed to update override price!", "error");
            } finally {
                setDisable(false);
            }
        } else {
            showToast("Override Price or Override Display Price is required!", "error");
        }
    };


    const handleRevertSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setDisableRevert(true);

        await updateProductOverridePriceApi({
            productId: productId,
            overridePrice: null,
            overrideDisplayPrice: null,
        });

        setShow(false);
    };

    return (
        <Modal
            title={"Override Product Price"}
            show={show}
            setShow={setShow}
            className="w-2/5  bg-text-0 rounded-lg shadow-lg"
            fields={
                <Form onSubmit={handleSubmit} fields={
                    <div className=" ">
                        <InputField
                            label="Price"
                            name="existingPrice"
                            value={existingPrice}
                            type="text"
                            className="mb-2"
                            disabled
                        />

                        <InputField
                            label="Override Price"
                            name="overridePrice"
                            value={overridePrice}
                            type="text"
                            onChange={(e) =>
                                setOverridePrice(e.target.value)
                            }
                            className="mb-2"
                        />
                        <InputField
                            label="Display Price"
                            name="existingDisplayPrice"
                            value={existingDisplayPrice}
                            type="text"
                            disabled
                        />

                        <InputField
                            label="Override Display Price"
                            name="overrideDisplayPrice"
                            value={overrideDisplayPrice}
                            type="text"
                            onChange={(e) =>
                                setOverrideDisplayPrice(e.target.value)
                            }
                        />
                        <div className={'mt-4 border-t border-t-surface-5 flex justify-end'}>
                            <ButtonTray
                                buttons={[
                                    {
                                        buttonProps: {
                                            btnText: "Cancel",
                                            onClick: () => setShow(false),
                                            type: "close",
                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Submit",
                                            isLoading: updateProductOverridePriceRes.isLoading,
                                            type: "submit",

                                        },
                                        buttonType: "button"
                                    },
                                    {
                                        buttonProps: {
                                            btnText: "Revert",
                                            isLoading: updateProductOverridePriceRes.isLoading,
                                            type: "revert",
                                            onClick: handleRevertSubmit,
                                            isVisible: (existingOverridePrice != null && existingOverridePrice !== "") ||
                                                (existingOverrideDisplayPrice !== null && existingOverrideDisplayPrice !== ""),
                                            className: "text-surface-5"
                                        },
                                        buttonType: "button",
                                    }
                                ]}
                                align={"start"}
                                gap={2}
                            />
                        </div>



                    </div >
                } />

            }

        />
    )
};

export default OverridePriceModal;